import React from "react";
import otherskillsicon from "../assets/images/otherskillsicon.svg";

const OtherSkills = () => {
  return (
    <div className="bg-white shadow-sm py-4 px-5 position-relative">
      <h4 className="text-center mb-3 mt-5">Others</h4>
      <div className="skills-icon-holder position-absolute d-inline-block rounded-circle text-center bg-light">
        <img className="text-center" src={otherskillsicon} alt="Others" />
      </div>
      <ul>
        <li>UX/Wireframing</li>
        <li>Adobe Design XD</li>
        <li>Adobe Illustrator</li>
        <li>Adobe AfterEffects</li>
      </ul>
    </div>
  );
};

export default OtherSkills;
